import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-public-layout-footer',
  templateUrl: './public-layout-footer.component.html',
  styleUrls: ['./public-layout-footer.component.scss']
})
export class PublicLayoutFooterComponent implements OnInit {

  currentYear: string;
  constructor() { }

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear().toString();
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

}
